import { Input } from "@/shared/ui/input";
import { Label } from "@/shared/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { MapPin } from "lucide-react";
import type { SignupFormData } from "./types";

interface Step3Props {
  formData: SignupFormData;
  onChange: (field: keyof SignupFormData, value: string) => void;
}

export function Step3PropertyAddress({ formData, onChange }: Step3Props) {
  return (
    <Card className="border-border bg-gradient-accent">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-foreground">
          <MapPin className="h-5 w-5 text-primary" />
          Property Address
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label htmlFor="propertyAddress" className="text-foreground">
            Enter your property address
          </Label>
          <Input
            id="propertyAddress"
            value={formData.propertyAddress}
            onChange={(e) => onChange("propertyAddress", e.target.value)}
            className="bg-background border-border text-foreground"
            placeholder="123 Main Street, City, State, ZIP"
          />
          <p className="text-sm text-muted-foreground mt-2">
            We'll automatically generate property details based on this address
          </p>
        </div>

        {formData.propertyAddress && (
          <div className="bg-background rounded-lg p-4 border border-border">
            <h4 className="font-semibold text-foreground mb-2">Generated Property Details:</h4>
            <div className="space-y-1 text-sm text-muted-foreground">
              <p>• Property Type: Detected automatically</p>
              <p>• Square Footage: Estimated from records</p>
              <p>• Year Built: Retrieved from database</p>
              <p>• Zoning Information: Commercial/Residential</p>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
